var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7467 5.63317C13.0467 2.55317 10.36 1.1665 8 1.1665C8 1.1665 8 1.1665 7.99334 1.1665C5.64 1.1665 2.94667 2.5465 2.24667 5.6265C1.46667 9.0665 3.57334 11.9798 5.48 13.8132C6.18667 14.4932 7.09334 14.8332 8 14.8332C8.90667 14.8332 9.81334 14.4932 10.5133 13.8132C12.42 11.9798 14.5267 9.07317 13.7467 5.63317ZM8 8.97317C6.84 8.97317 5.9 8.03317 5.9 6.87317C5.9 5.71317 6.84 4.77317 8 4.77317C9.16 4.77317 10.1 5.71317 10.1 6.87317C10.1 8.03317 9.16 8.97317 8 8.97317Z",
    fill: "#284355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.95109a03d02bb87a98f429e55a1bfe7d.svg";
export { ForwardRef as ReactComponent };